export const HAMBURGER_BREAK_POINT = '@media (max-width:1148px)';

export const HIDE_SEARCH_BREAK_POINT = '@media (max-width:312px)';
